import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";
import { SendToCart } from "./AddToCartRedux";

export const fetchGallery = createAsyncThunk(
  "fetchGallery",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"",

        {
          Search: data1["Search"],
          PageNo: data1["PageNo"],
          SortBy: data1["SortBy"],
          // orders: [1, 2, 3],
          // photo: document.querySelector('#fileInput').files
        },
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399) {
        localStorage.clear();
        window.location.assign("/");
      }
      if (error.code === "ERR_NETWORK") {
        return rejectWithValue("ERROR");
      }
    }
  }
);

const gallerySlice = createSlice({
  name: "gallery",
  initialState: {
    isLoading: "hide",
    isEmpty: "hide",
    data: null,
    isError: "hide",
  },
  reducers: {
    galleryError(state, action) {
      state.isError = "";
      state.isEmpty = "hide";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGallery.fulfilled, (state, action) => {
        state.isLoading = "hide";
        state.isEmpty = "hide";
        if (action.payload === "[NoDataFound]") {
          state.data = [];
          state.isEmpty = "";
        } else {
          state.data = action.payload;
        }

        state.isError = "hide";
      })
      .addCase(fetchGallery.pending, (state, action) => {
        state.isLoading = "";
        state.isEmpty = "hide";
        state.isError = "hide";
      })
      .addCase(fetchGallery.rejected, (state, action) => {
        state.isError = "";
        state.isEmpty = "hide";
        state.isLoading = "hide";
      })
      .addCase(SendToCart.fulfilled, (state, action) => {
        let tmpData = [];
        // console.log(state.data)
        for (let i = 0; current(state.data).length > i; i++) {
            // console.log("IN LOOP")
          if (current(state.data)[i]["UID"] !== action.payload["AddedToCart"]) {
            tmpData.push(current(state.data)[i]);
          } else {
            let tmp2 = {};
            for (const [key, value] of Object.entries(current(state.data)[i])) {
              tmp2[key] = value;
            }
            tmp2["CQty"] = action.payload["TotalInCart"];
            tmpData.push(tmp2);
          }
        }
        state.data = tmpData;
      });
  },
});

export default gallerySlice.reducer;
